import Vue from "vue";
import Vuex from "vuex";

import users from "./modules/users.module";
import references from "./modules/references.module";
import attributeTemplates from "./modules/attributeTemplates.module";
import objectTypes from "./modules/objectTypes.module";
import objectTemplates from "./modules/objectTemplates.module";
import settings from "./modules/settings.module";
import objects from "./modules/objects.module";
import attributeValue from "./modules/attributeValue.module";
import thePictureEditor from "./modules/thePictureEditor.module";
import theFileUploader from "./modules/theFileUploader.module";
import objectComplexValue from "./modules/objectComplexValue.module";
import objectSetting from "./modules/objectSetting.module";
import textEditor from "./modules/textEditor.module";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    users,
    references,
    attributeTemplates,
    objectTemplates,
    settings,
    objectTypes,
    objects,
    attributeValue,
    thePictureEditor,
    theFileUploader,
    objectComplexValue,
    objectSetting,
    textEditor
  },
  strict: process.env.NODE_ENV !== "production"
});

export default store;
